import React from "react";

import Form from "2g-form";
import PageHeading from "2g-page-heading";

import FormSwitchesContentExample from "./FormSwitchesContentExample";

export function FormSwitchesExample() {
  return (
    <>
      <PageHeading>Switches</PageHeading>
      <Form moduleKey="switchesExample">
        <FormSwitchesContentExample />
      </Form>
    </>
  );
}

export default React.memo(FormSwitchesExample);
